import { PageSizeOption, UIFilters } from './types'
import { GridSortItem } from '@mui/x-data-grid-pro'

type State = {
  currentPage: number
  previewHighschoolId?: string | null
  selectedSchools: string[]
  pageSize: PageSizeOption
  sortModel: GridSortItem[]
  filters: UIFilters
  isFilterDrawerOpen: boolean
}

type Action =
  | {
      type: 'page-change'
      newPage: number
    }
  | { type: 'pageSize-change'; pageSize: PageSizeOption }
  | { type: 'sortModel-change'; sortModel: GridSortItem[] }
  | { type: 'filter-change'; filters: UIFilters }
  | { type: 'filter-drawer-toggled'; isOpen: boolean }
  | { type: 'preview-highschool-change'; previewHighschoolId: string | null }
  | { type: 'selection-change'; selectedSchools: string[] }

export default function highSchoolExploreReducer(state: State, action: Action): State {
  switch (action.type) {
    case 'preview-highschool-change':
      return { ...state, previewHighschoolId: action.previewHighschoolId }
    case 'page-change':
      return {
        ...state,
        currentPage: action.newPage,
      }
    case 'pageSize-change':
      return { ...state, pageSize: action.pageSize }
    case 'sortModel-change':
      return { ...state, sortModel: action.sortModel }
    case 'filter-change':
      return {
        ...state,
        filters: action.filters,
        isFilterDrawerOpen: false,
      }
    case 'filter-drawer-toggled':
      return {
        ...state,
        isFilterDrawerOpen: action.isOpen,
      }
    case 'selection-change':
      return {
        ...state,
        selectedSchools: action.selectedSchools,
      }
  }
}
